var _style, _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgLoopMessagelogo = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "\u0421\u043B\u043E\u0439_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1024 867",
    style: {
      enableBackground: "new 0 0 1024 867"
    },
    xmlSpace: "preserve",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#138779;}\n\t.st1{fill:#25D366;}\n\t.st2{fill:url(#SVGID_1_);}\n\t.st3{fill:url(#SVGID_2_);}\n\t.st4{fill:url(#SVGID_3_);}\n\t.st5{fill:url(#SVGID_4_);}\n\t.st6{fill:url(#SVGID_5_);}\n\t.st7{fill:url(#SVGID_6_);}\n\t.st8{fill:url(#SVGID_7_);}\n\t.st9{fill:url(#SVGID_8_);}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M333.27,675.58c4.49,0,8.14,1.14,10.95,3.42c2.81,2.28,4.67,5.5,5.6,9.66h-1.49l0.69-1.78    c0.79-1.85,2.14-3.63,4.06-5.35c1.91-1.72,4.13-3.14,6.64-4.26c2.51-1.12,5.12-1.69,7.83-1.69c4.36,0,7.79,0.94,10.3,2.83    c2.51,1.88,4.31,4.39,5.4,7.53c1.09,3.14,1.63,6.65,1.63,10.55v27.05c0,1.12-0.38,2.08-1.14,2.87c-0.76,0.79-1.73,1.19-2.92,1.19    c-1.12,0-2.07-0.4-2.82-1.19s-1.14-1.75-1.14-2.87v-26.85c0-2.51-0.36-4.81-1.09-6.89c-0.73-2.08-1.95-3.75-3.67-5.01    c-1.72-1.25-4.03-1.88-6.94-1.88c-2.64,0-5.09,0.63-7.33,1.88c-2.25,1.26-4.03,2.92-5.35,5.01c-1.32,2.08-1.98,4.38-1.98,6.89    v26.85c0,1.12-0.36,2.08-1.09,2.87c-0.73,0.79-1.68,1.19-2.87,1.19c-1.19,0-2.15-0.4-2.87-1.19c-0.73-0.79-1.09-1.75-1.09-2.87    v-27.15c0-2.44-0.37-4.69-1.09-6.74c-0.73-2.05-1.92-3.68-3.57-4.9c-1.65-1.22-3.9-1.83-6.74-1.83c-2.64,0-5.05,0.61-7.23,1.83    c-2.18,1.22-3.93,2.85-5.25,4.9c-1.32,2.05-1.98,4.29-1.98,6.74v27.15c0,1.12-0.38,2.08-1.14,2.87s-1.7,1.19-2.82,1.19    s-2.07-0.4-2.82-1.19c-0.76-0.79-1.14-1.75-1.14-2.87v-43.1c0-1.19,0.38-2.16,1.14-2.92c0.76-0.76,1.7-1.14,2.82-1.14    c1.19,0,2.15,0.38,2.87,1.14c0.73,0.76,1.09,1.74,1.09,2.92v7.43l-2.18,2.37c0.26-1.71,0.94-3.43,2.03-5.15    c1.09-1.72,2.49-3.3,4.21-4.75c1.72-1.45,3.63-2.61,5.75-3.47C328.65,676.02,330.9,675.58,333.27,675.58z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M422.74,728.59c-5.28,0-9.91-1.12-13.87-3.37c-3.96-2.24-7.05-5.34-9.26-9.27    c-2.21-3.93-3.32-8.47-3.32-13.62c0-5.75,1.14-10.65,3.42-14.71c2.28-4.06,5.25-7.17,8.92-9.32c3.67-2.14,7.55-3.22,11.64-3.22    c3.1,0,6.06,0.56,8.87,1.69c2.81,1.12,5.32,2.77,7.53,4.95c2.21,2.18,3.98,4.75,5.3,7.72c1.32,2.98,2.01,6.34,2.08,10.11    c-0.07,1.06-0.5,1.93-1.29,2.62c-0.79,0.69-1.72,1.04-2.77,1.04h-39.14l-1.78-6.84h38.14l-1.59,1.39v-2.18    c-0.26-2.71-1.17-5.03-2.72-6.98c-1.55-1.95-3.43-3.45-5.65-4.51c-2.21-1.05-4.54-1.58-6.98-1.58c-1.98,0-3.95,0.36-5.89,1.09    s-3.7,1.85-5.25,3.37c-1.55,1.52-2.79,3.5-3.72,5.95c-0.93,2.44-1.39,5.38-1.39,8.82c0,3.83,0.78,7.2,2.33,10.1    c1.55,2.91,3.72,5.2,6.49,6.89c2.77,1.69,5.98,2.52,9.61,2.52c2.38,0,4.41-0.29,6.09-0.89c1.68-0.6,3.15-1.34,4.41-2.23    c1.25-0.89,2.31-1.8,3.17-2.72c0.86-0.6,1.69-0.89,2.48-0.89c0.99,0,1.82,0.33,2.48,0.99c0.66,0.66,0.99,1.46,0.99,2.38    c0,1.12-0.56,2.15-1.69,3.07c-1.85,2.04-4.36,3.83-7.53,5.35C429.67,727.83,426.3,728.59,422.74,728.59z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M452.46,719.47c-0.53-0.86-0.78-1.76-0.74-2.72c0.03-0.95,0.58-1.8,1.63-2.52c0.73-0.46,1.54-0.66,2.43-0.6    c0.89,0.07,1.7,0.49,2.43,1.29c1.85,2.18,3.96,3.91,6.34,5.2c2.38,1.29,5.28,1.93,8.72,1.93c1.52-0.07,3.09-0.33,4.71-0.8    c1.62-0.46,2.97-1.27,4.06-2.43c1.09-1.15,1.64-2.69,1.64-4.61c0-1.85-0.56-3.32-1.69-4.41c-1.12-1.09-2.59-1.98-4.41-2.68    s-3.75-1.3-5.79-1.83c-2.18-0.6-4.33-1.26-6.44-1.98c-2.12-0.73-4.01-1.67-5.7-2.82c-1.69-1.15-3.04-2.61-4.06-4.36    c-1.02-1.75-1.54-3.92-1.54-6.49c0-2.98,0.81-5.55,2.43-7.73c1.62-2.18,3.78-3.86,6.49-5.05c2.71-1.19,5.71-1.78,9.02-1.78    c1.85,0,3.78,0.21,5.79,0.64c2.02,0.43,3.98,1.16,5.9,2.18c1.91,1.02,3.6,2.43,5.05,4.21c0.59,0.66,0.92,1.49,0.99,2.48    c0.07,0.99-0.36,1.88-1.29,2.67c-0.73,0.53-1.53,0.78-2.43,0.74c-0.89-0.03-1.64-0.35-2.23-0.94c-1.45-1.72-3.22-3.02-5.3-3.92    c-2.08-0.89-4.37-1.34-6.88-1.34c-1.52,0-3.04,0.25-4.56,0.74c-1.52,0.5-2.79,1.28-3.81,2.33c-1.02,1.06-1.54,2.55-1.54,4.46    c0.07,1.78,0.66,3.24,1.78,4.36c1.12,1.13,2.64,2.03,4.56,2.72c1.91,0.69,4.03,1.37,6.34,2.03c2.11,0.53,4.14,1.14,6.09,1.83    c1.95,0.69,3.72,1.6,5.3,2.72c1.59,1.13,2.84,2.56,3.76,4.31c0.92,1.75,1.39,3.95,1.39,6.59c0,3.04-0.86,5.66-2.57,7.87    c-1.72,2.22-3.98,3.9-6.79,5.06c-2.81,1.15-5.83,1.73-9.07,1.73c-3.63,0-7.23-0.68-10.8-2.03    C458.11,725.21,455.04,722.85,452.46,719.47z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M499.42,719.47c-0.53-0.86-0.78-1.76-0.74-2.72c0.03-0.95,0.58-1.8,1.63-2.52c0.73-0.46,1.54-0.66,2.43-0.6    c0.89,0.07,1.7,0.49,2.43,1.29c1.85,2.18,3.96,3.91,6.34,5.2c2.38,1.29,5.28,1.93,8.72,1.93c1.52-0.07,3.08-0.33,4.71-0.8    c1.62-0.46,2.97-1.27,4.06-2.43c1.09-1.15,1.64-2.69,1.64-4.61c0-1.85-0.56-3.32-1.69-4.41c-1.13-1.09-2.59-1.98-4.41-2.68    s-3.75-1.3-5.79-1.83c-2.18-0.6-4.33-1.26-6.44-1.98c-2.12-0.73-4.01-1.67-5.7-2.82c-1.69-1.15-3.04-2.61-4.06-4.36    c-1.02-1.75-1.54-3.92-1.54-6.49c0-2.98,0.81-5.55,2.43-7.73c1.62-2.18,3.78-3.86,6.49-5.05c2.71-1.19,5.71-1.78,9.02-1.78    c1.85,0,3.78,0.21,5.79,0.64c2.02,0.43,3.98,1.16,5.9,2.18c1.91,1.02,3.59,2.43,5.05,4.21c0.59,0.66,0.92,1.49,0.99,2.48    c0.07,0.99-0.36,1.88-1.29,2.67c-0.73,0.53-1.54,0.78-2.43,0.74c-0.89-0.03-1.64-0.35-2.23-0.94c-1.45-1.72-3.22-3.02-5.3-3.92    c-2.08-0.89-4.37-1.34-6.88-1.34c-1.52,0-3.04,0.25-4.56,0.74c-1.52,0.5-2.79,1.28-3.81,2.33c-1.02,1.06-1.54,2.55-1.54,4.46    c0.07,1.78,0.66,3.24,1.78,4.36c1.12,1.13,2.64,2.03,4.56,2.72c1.91,0.69,4.03,1.37,6.34,2.03c2.11,0.53,4.14,1.14,6.1,1.83    c1.95,0.69,3.72,1.6,5.3,2.72c1.59,1.13,2.84,2.56,3.77,4.31c0.92,1.75,1.39,3.95,1.39,6.59c0,3.04-0.86,5.66-2.57,7.87    c-1.72,2.22-3.98,3.9-6.79,5.06c-2.81,1.15-5.83,1.73-9.06,1.73c-3.63,0-7.23-0.68-10.8-2.03    C505.07,725.21,502,722.85,499.42,719.47z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M591.86,675.88c1.19,0,2.15,0.38,2.87,1.14s1.09,1.7,1.09,2.82v43.69c0,1.12-0.38,2.08-1.14,2.87    c-0.76,0.79-1.7,1.19-2.83,1.19c-1.19,0-2.15-0.4-2.87-1.19s-1.09-1.75-1.09-2.87v-9.41l1.88-0.2c0,1.52-0.49,3.12-1.49,4.81    c-0.99,1.69-2.34,3.27-4.06,4.75c-1.72,1.49-3.75,2.71-6.1,3.66c-2.34,0.96-4.84,1.44-7.48,1.44c-4.56,0-8.62-1.17-12.19-3.52    c-3.57-2.35-6.39-5.53-8.47-9.56c-2.08-4.03-3.12-8.62-3.12-13.77c0-5.22,1.04-9.82,3.12-13.82c2.08-4,4.91-7.13,8.47-9.41    c3.57-2.28,7.53-3.42,11.89-3.42c2.84,0,5.48,0.46,7.92,1.39c2.44,0.93,4.57,2.18,6.39,3.76c1.82,1.59,3.24,3.34,4.26,5.25    c1.02,1.92,1.53,3.83,1.53,5.75l-2.57-0.59v-10.8c0-1.12,0.36-2.06,1.09-2.82S590.67,675.88,591.86,675.88z M571.45,721.26    c3.3,0,6.23-0.86,8.77-2.57c2.54-1.71,4.53-4.04,5.95-6.98c1.42-2.94,2.13-6.26,2.13-9.96c0-3.63-0.71-6.9-2.13-9.81    c-1.42-2.91-3.4-5.21-5.95-6.93c-2.54-1.72-5.47-2.57-8.77-2.57c-3.24,0-6.13,0.84-8.67,2.52s-4.54,3.98-5.99,6.89    c-1.45,2.91-2.18,6.21-2.18,9.91c0,3.7,0.73,7.02,2.18,9.96c1.45,2.94,3.45,5.27,5.99,6.98    C565.32,720.4,568.21,721.26,571.45,721.26z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M631.49,675.09c2.84,0,5.48,0.48,7.92,1.43c2.44,0.96,4.58,2.2,6.39,3.72c1.82,1.52,3.24,3.11,4.26,4.76    c1.02,1.65,1.54,3.2,1.54,4.66l-1.89-1.19v-8.62c0-1.12,0.36-2.06,1.09-2.82s1.69-1.14,2.87-1.14c1.19,0,2.15,0.38,2.88,1.14    c0.72,0.76,1.09,1.7,1.09,2.82v43.4c0,5.42-1.14,9.92-3.42,13.52c-2.28,3.6-5.34,6.28-9.17,8.03s-8.09,2.63-12.78,2.63    c-1.98,0-4.18-0.25-6.59-0.74c-2.41-0.49-4.54-1.12-6.39-1.88c-1.85-0.76-3.01-1.54-3.47-2.33c-0.99-0.73-1.62-1.49-1.88-2.28    c-0.27-0.8-0.14-1.59,0.4-2.38c0.6-0.93,1.37-1.39,2.33-1.39s2.17,0.3,3.62,0.89c0.59,0.2,1.54,0.53,2.82,0.99    c1.29,0.46,2.76,0.88,4.41,1.24c1.65,0.36,3.27,0.54,4.86,0.54c5.55,0,9.82-1.47,12.83-4.41c3.01-2.94,4.51-6.82,4.51-11.64v-9.21    l1.09,0.5c-0.4,1.85-1.21,3.57-2.43,5.15c-1.22,1.59-2.69,2.99-4.41,4.21c-1.72,1.22-3.65,2.18-5.8,2.87    c-2.15,0.69-4.31,1.04-6.49,1.04c-4.62,0-8.79-1.15-12.48-3.47c-3.7-2.31-6.63-5.48-8.77-9.51c-2.15-4.03-3.22-8.62-3.22-13.77    c0-5.22,1.08-9.84,3.22-13.87c2.14-4.03,5.05-7.18,8.72-9.46S626.93,675.09,631.49,675.09z M632.58,682.42    c-3.43,0-6.47,0.84-9.11,2.52c-2.64,1.69-4.73,4-6.24,6.94c-1.52,2.94-2.28,6.26-2.28,9.96c0,3.63,0.76,6.92,2.28,9.86    c1.52,2.94,3.6,5.27,6.24,6.98c2.64,1.72,5.68,2.57,9.11,2.57c3.37,0,6.37-0.84,9.02-2.52c2.64-1.69,4.72-3.98,6.24-6.89    s2.28-6.24,2.28-10.01s-0.76-7.11-2.28-10.06c-1.52-2.94-3.6-5.23-6.24-6.89C638.95,683.25,635.95,682.42,632.58,682.42z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M693.51,728.59c-5.28,0-9.9-1.12-13.87-3.37c-3.96-2.24-7.05-5.34-9.26-9.27c-2.21-3.93-3.32-8.47-3.32-13.62    c0-5.75,1.14-10.65,3.42-14.71c2.28-4.06,5.25-7.17,8.92-9.32c3.67-2.14,7.55-3.22,11.64-3.22c3.11,0,6.06,0.56,8.87,1.69    c2.81,1.12,5.31,2.77,7.53,4.95c2.21,2.18,3.98,4.75,5.3,7.72c1.32,2.98,2.02,6.34,2.08,10.11c-0.07,1.06-0.49,1.93-1.29,2.62    c-0.79,0.69-1.72,1.04-2.77,1.04h-39.14l-1.78-6.84h38.14l-1.59,1.39v-2.18c-0.26-2.71-1.17-5.03-2.72-6.98    c-1.55-1.95-3.43-3.45-5.65-4.51c-2.21-1.05-4.54-1.58-6.98-1.58c-1.98,0-3.94,0.36-5.89,1.09c-1.95,0.73-3.7,1.85-5.25,3.37    c-1.56,1.52-2.79,3.5-3.72,5.95c-0.93,2.44-1.39,5.38-1.39,8.82c0,3.83,0.77,7.2,2.33,10.1c1.55,2.91,3.72,5.2,6.49,6.89    c2.77,1.69,5.97,2.52,9.61,2.52c2.37,0,4.4-0.29,6.09-0.89c1.69-0.6,3.15-1.34,4.41-2.23c1.25-0.89,2.31-1.8,3.17-2.72    c0.86-0.6,1.69-0.89,2.48-0.89c0.99,0,1.82,0.33,2.48,0.99c0.66,0.66,0.99,1.46,0.99,2.38c0,1.12-0.56,2.15-1.69,3.07    c-1.85,2.04-4.36,3.83-7.53,5.35C700.44,727.83,697.07,728.59,693.51,728.59z"
  })))), /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M450.28,568.72c-5.89-0.46-11.69-1.02-17.27-1.76c27.98-27.91,45.88-73.42,45.88-125.81   c0-86.9-49.22-154.96-112.05-154.96S254.8,354.25,254.8,441.14c0,54.37,19.27,101.37,49.09,128.93   c-25.94,3.3-55.8,0.46-88.16-14.47c-24.86-11.47-43.44-54.21-52.23-118.89c39.49-53.1,82.6-125.17,104.72-208.14   c24.47-91.77,23.28-152.21-3.65-184.79c-14.78-17.88-36.1-26.36-61.7-24.54c-13.51,0.97-54.62,3.9-82.06,154.26   c-14.74,80.75-19.18,173.34-11.89,247.82c-35.07,44.6-64.21,71.36-64.83,71.92l17.61,19.43l17.6,19.44   c1.92-1.74,18.2-16.64,40.78-42.04c14.36,59.22,39.03,97.17,73.67,113.16c31.39,14.49,61.74,20.27,89.99,20.27   c31.24,0,59.88-7.1,84.47-17.35c19.49,6.18,41.69,11,65.88,13.69C434.87,601.02,438.34,583.2,450.28,568.72z M171.13,190.01   c13.88-80.26,31.59-111.79,38.32-118.56h0.09c9.85,0,13.14,3.97,14.61,5.76c5.35,6.47,20.68,35.54-6.61,137.86   c-13.31,49.91-35.47,96-59.59,135.73C157.68,298.38,162.24,241.45,171.13,190.01z M400.55,524.18c-3.46,3.25-10.75,9.67-21.35,16.8   c-4.12,1.7-8.27,2.68-12.36,2.68c-28.19,0-59.6-42.1-59.6-102.51s31.41-102.51,59.6-102.51c28.19,0,59.6,42.1,59.6,102.51   C426.44,476.92,415.39,506.19,400.55,524.18z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M867.48,286.18c-26.06,0-49.77,11.74-68.61,31.65c-0.33-1.82-0.63-3.6-0.97-5.44l-51.93,6.83   c3.32,42.28,6.89,111.51,7.23,185.97c-6.43,28.35-18.05,48.28-34.74,58.8c-16.34,10.3-37.07,11.66-57.78,8.49   c31.37-27.18,51.83-75.33,51.83-131.35c0-86.9-49.22-154.96-112.05-154.96s-112.05,68.07-112.05,154.96   c0,51.33,17.18,96.08,44.19,124.12c-30.41,5.38-58.33,5.9-83.13,3.6c-9.17,15.67-16.53,31.95-19.69,50.17   c14.88,1.97,30.57,3.08,46.97,3.08c34.96,0,73-4.98,112.6-16.98c43.65,19.3,107.22,34.64,157.06,3.22   c1.72-1.08,3.41-2.21,5.06-3.39c-4.08,96.19-16,185.16-43.14,220.78l41.72,31.78c39.21-51.45,52.41-171.96,55.26-286.76   c17.68,16.04,38.99,25.32,62.15,25.32c62.83,0,112.05-68.07,112.05-154.96S930.32,286.18,867.48,286.18z M617.11,538.96   c-2.41,1.08-4.8,2.08-7.19,3.09c-3.16,1-6.32,1.6-9.45,1.6c-28.19,0-59.6-42.1-59.6-102.51s31.41-102.51,59.6-102.51   c28.19,0,59.6,42.1,59.6,102.51C660.08,489.75,639.74,526.45,617.11,538.96z M867.48,543.66c-23.28,0-48.71-28.76-56.88-72.8   c1.22-18.19,1.21-37.92-0.04-59.21c8.12-44.16,33.59-73.02,56.91-73.02c28.19,0,59.6,42.1,59.6,102.51S895.67,543.66,867.48,543.66   z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 178.507,
    y1: 588.7512,
    x2: 367.5387,
    y2: 588.7512
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3466,
    style: {
      stopColor: "#25D366"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4043,
    style: {
      stopColor: "#21CB64"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9762,
    style: {
      stopColor: "#008454"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M193.74,603.23c31.39,14.49,61.74,20.27,89.99,20.27c30.96,0,59.36-6.98,83.8-17.09    c-22.15-0.78-67.64-40.02-63.66-36.34c-25.94,3.3-55.8,0.46-88.16-14.47c-0.99-0.46-1.96-1.05-2.93-1.61    c-12.49,8.01-27.46,23.66-34.29,40.24C183.36,597.73,188.42,600.77,193.74,603.23z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 382.281,
    y1: 610.3658,
    x2: 383.5315,
    y2: 610.3658
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3466,
    style: {
      stopColor: "#25D366"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4043,
    style: {
      stopColor: "#21CB64"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9762,
    style: {
      stopColor: "#008454"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M382.28,610.22c0.37,0.1,0.76,0.19,1.13,0.29c0.05-0.04,0.12-0.1,0.12-0.1S383.03,610.34,382.28,610.22z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 423.7679,
    y1: 593.8798,
    x2: 592.3727,
    y2: 593.8798
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3466,
    style: {
      stopColor: "#25D366"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4043,
    style: {
      stopColor: "#21CB64"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9762,
    style: {
      stopColor: "#008454"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M535.01,565.64c-31.34,5.3-60.01,5.51-85.26,2.78c-9.16,15.6-16.55,31.8-19.81,49.9   c16.26,2.38,33.46,3.81,51.6,3.81c34.44,0,71.87-4.87,110.83-16.48C575.82,597.84,554.1,585.05,535.01,565.64z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 418.5852,
    y1: 451.9033,
    x2: 418.5852,
    y2: 566.9993
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3466,
    style: {
      stopColor: "#25D366"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4043,
    style: {
      stopColor: "#21CB64"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9762,
    style: {
      stopColor: "#008454"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M433.01,566.96c22.77-22.72,38.87-57.1,44.07-97.35c-11.48-19.42-40.15-18.34-51.07-17.14   c-2.05,30.61-12.22,55.66-25.46,71.71c-3.46,3.25-10.75,9.67-21.35,16.8c-4.12,1.7-8.27,2.68-12.36,2.68   c-2.24,0-4.49-0.36-6.75-0.87C393.57,563.61,436.74,567.46,433.01,566.96z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 652.2178,
    y1: 451.9033,
    x2: 652.2178,
    y2: 572.2845
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3466,
    style: {
      stopColor: "#25D366"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4043,
    style: {
      stopColor: "#21CB64"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9762,
    style: {
      stopColor: "#008454"
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M660.08,572.27c28.61-23.84,45.43-62.4,50.63-102.66c-11.48-19.42-40.15-18.34-51.07-17.14   c-2.05,30.61-12.22,55.66-25.46,71.71c-3.46,3.25-10.75,9.67-21.35,16.8c-4.12,1.7-8.27,2.68-12.36,2.68   c-2.24,0-4.49-0.36-6.75-0.87C627.21,563.61,663.81,572.76,660.08,572.27z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 81.592,
    y1: 238.2038,
    x2: 169.7449,
    y2: 390.8891
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3466,
    style: {
      stopColor: "#25D366"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4043,
    style: {
      stopColor: "#21CB64"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9762,
    style: {
      stopColor: "#008454"
    }
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M157.94,350.71c-0.2-40.05,2.44-82.72,7.66-123.58l-51.96-7.42c-8.83,68.44-10.66,141.02-4.73,201.61   c-2.35,2.99-4.68,5.89-6.97,8.72C124.11,406.97,151.37,361.81,157.94,350.71z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 871.4787,
    y1: 636.1022,
    x2: 764.8198,
    y2: 503.6123
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3265,
    style: {
      stopColor: "#25D366"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3882,
    style: {
      stopColor: "#21CB64"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#008454"
    }
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M940.03,560.1c-6.37-18.02-16.37-36.02-28.04-52.24c-11.73,22.45-28.63,35.8-44.5,35.8   c-22.29,0-46.5-26.39-55.69-67.27c0,0.01,0,0.02,0,0.02c-0.57,78.48-36.25,114.62-60.36,130.1c-0.81,18.67-1.92,37.06-3.38,54.83   c10.23,9.46,26.16,17.12,50.85,18.88c3.54-35.44,5.52-72.73,6.43-109.44c17.68,16.04,38.99,25.32,62.15,25.32   C895.4,596.11,920.61,582.65,940.03,560.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 845.2639,
    y1: 286.1844,
    x2: 845.2639,
    y2: 435.6745
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3466,
    style: {
      stopColor: "#25D366"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4043,
    style: {
      stopColor: "#21CB64"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9762,
    style: {
      stopColor: "#008454"
    }
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M799.4,317.31c2.88,20.34,10.78,78.93,12.01,118.37c-0.11-7.8-0.35-15.76-0.84-24.03   c8.12-44.16,33.59-73.02,56.91-73.02c5.42,0,10.96,1.59,16.38,4.54c4.05-14.67,9.03-37.42,6.64-53.84   c-7.41-2.06-15.11-3.15-23.02-3.15C841.66,286.18,818.15,297.72,799.4,317.31z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLoopMessagelogo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/LoopMessagelogo.3eb72ef0cf85a8809168afee27879f0c.svg";